<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col">
        <bd-tree v-if="show" :options="options"></bd-tree>
      </div>
    </div>

    <div class="row">
      <div class="col">
        <vs-table v-if="show" ref="table" :params="params" ></vs-table>
      </div>
    </div>
  </div>

</template>

<script>
import BdTree from "../components/BDTree.vue";
import EventBus from "../bus.js";
import VsTable from "../_framework/VsTable.vue";

export default {
  name: "accounts-titles",
  created: () => {},
  components: {
    BdTree,
    VsTable
  },
  data() {
    return {
      show: true,
      access: {},
      options: {
        entityName: "accounttitle",
        levelLimit: 3,
        levelLabel: "accontType",
        fields: {
          code: {
            title: "کد حساب",
            type: "text"
          },
          title: {
            title: "عنوان حساب",
            type: "text"
          }
        }
      },
      params: {
        entity: "accounts-titles",
        list: [],
        headers: {
          accountCode: {
            title: "کد حساب",
            type: "text"
          },
          accountDescription: {
            title: "عنوان حساب",
            type: "text"
          },
          accountLevel: {
            title: "سطح حساب",
            type: "text"
          },
          accountGroup: {
            title: "گروه حساب",
            type: "text"
          },
          residueType: {
            title: "نوع مانده",
            type: "text"
          },
        }
      },
    };
  },
  methods: {},
  mounted() {
    EventBus.$on("selectTreeNode", data => {
      this.$emit("selectAccountTitle", data);
    });
    EventBus.$on("doubleClickedSelect", () => {
      this.$emit("dblClicked");
    });
  },
  beforeMount() {
    if (this.$route) {
      this.options.access = checkAccess(this.$route.path);
      this.show = this.options.access ? true : false;
    }
  }
};
</script>
